export interface ServiceI {
  id: number;
  name: string;
  type: string;
  created: number;
  updated: number;
}

export interface ServicesStateI {
  services: ServiceI[];
  service: ServiceI;
}

export const state: ServicesStateI = {
  services: [],
  service: {
    id: 0,
    name: '',
    type: '',
    created: 0,
    updated: 0,
  },
};
